import NativeApplicationImg from "@assets/images/concept-sketch-of-a-native-app.webp";

export const data = {

    heading: "Native App Development Services We Offer ",

    text: 'As a leading app development agency, Apptalyst provides end-to-end native engineering:',

    list: [
        { boldText: 'iOS App Development', text: 'Specialized Swift development for iPhone, iPad, and Apple Watch, leveraging the latest SwiftUI frameworks.' },
        { boldText: 'Android App Development', text: 'High-performance Kotlin and Java applications optimized for the fragmented Android ecosystem and Google Play standards.' },
        { boldText: 'MVP Native Apps', text: 'We build lean native versions focusing on core features to help startups validate their product.' },
        { boldText: 'Enterprise Native Solutions', text: 'Secure, scalable architectures tailored for fintech, logistics, and healthcare industries.' },
        { boldText: 'Native App Rebuilds', text: ' We migrate laggy hybrid or PWA apps into fully native codebases to improve retention and speed.' },
        { boldText: 'UI/UX Design', text: 'Our designers create blueprints that ensure your app meets HIG and Material Design standards before a single line of code is written.' },
       
    ]
    , 
    img: NativeApplicationImg,
    altText: 'A native mobile application with many features and efficient hardware utilization.'

}